/**
 * @prop --wf-contact-display-title-color: The color of the box title, default (--mdc-theme-accent).
 * @prop --wf-contact-display-title-font-size: The font size of the title.
 * @prop --wf-contact-display-title-font-weight: The font weight of the title.
 * @prop --wf-contact-display-title-font-size-large: The font weight of the title in medium and large viewports.
 * @prop --wf-contact-display-box-background-color: The background color of the contact boxes.
 */
:host {
    box-sizing: border-box;
    display: block;
    padding: 16px 0;
    width: 100%;
}

a {
    color: currentcolor;
    text-decoration: none;
}

.title {
    line-height: 1.71;
    margin-bottom: 8px;
    color: var(--wf-contact-display-title-color, var(--mdc-theme-accent));
    font-size: var(--wf-contact-display-title-font-size, 0.875rem);
    font-weight: var(--wf-contact-display-title-font-weight, bold);
}

.rows {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.box {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 0 8px;
    border-radius: var(--mdc-shape-normal);
    background-color: var(--wf-contact-display-box-background-color, #f8f7f5);
    font-size: 16px;
    min-height: 44px;

    &-content div:nth-child(2) {
        font-size: 0.75em;
        color: var(--text-color-light, rgb(0 0 0 / 50%));
    }
}

.hidden {
    display: none;
}

@media screen and (min-width: 768px) {
    :host {
        padding: 16px 0;
    }

    .title {
        font-size: var(--wf-contact-display-title-font-size-large, 1rem);
    }
}
